module.exports = __webpack_public_path__ + "static/img/team-bg.489b89c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-bg.png
// module id = nW+u
// module chunks = 0